import React, { useState, forwardRef } from "react";
import "../../pages/deliveryNote/deliveryNote.scss";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const style = {
  control: (base) => ({
    ...base,
    boxShadow: "none",
    border: "1px solid #B4BABF",
    backgroundColor: "#F9FBFC",
    fontSize: "14px",
    minHeight: "35px",
    height: "35px",
    borderRadius: "6px",
    color: "#000000",
    whiteSpace: "nowrap",
  }),
};

const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />{" "}
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};

const colourOptions = [
  { value: "ocean1", label: "Ocean" },
  { value: "blue", label: "Blue" },
  { value: "purple", label: "Purple" },
  { value: "red", label: "Red" },
  { value: "orange", label: "Orange" },
  { value: "yellow", label: "Yellow" },
  { value: "green", label: "Green" },
  { value: "forest", label: "Forest" },
  { value: "slate", label: "Slate" },
  { value: "silver", label: "Silver" },
];
// datepicker start
const ExampleCustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
  <input
    value={value}
    className="example-custom-input form-control"
    onClick={onClick}
    onChange={onChange}
    ref={ref}
  ></input>
));
// datepicker end

function AddNewDeliveryProject() {
  const [startDate, setStartDate] = useState(new Date());

  const [distributertag, setDistributerTag] = useState([]);
  const handleChange = (selected) => {
    setDistributerTag(selected);
  };
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="row">
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
              <div>
                <label>
                  Packing List Ref <span className="mandatory">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Packing List Ref"
                ></input>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
              <div>
                <label>
                  Customer Name <span className="mandatory">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Customer Name"
                ></input>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
              <div>
                <label>
                  Delivery Note Ref <span className="mandatory">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Delivery Note Ref *"
                ></input>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
              <div className="row">
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                  <div>
                    <label>Contact Person</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Contact Person"
                    ></input>
                  </div>
                </div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                  <div>
                    <label>Contact Number</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Contact Number"
                    ></input>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                  <div>
                    <label>Email Address</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Email Address"
                    ></input>
                  </div>
                </div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                  <div>
                    <label>
                      Customer LPO <span className="mandatory">*</span>
                    </label>
                    <ReactSelect
                      className="basic-multi-select"
                      options={colourOptions}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{
                        Option,
                      }}
                      onChange={handleChange}
                      allowSelectAll={true}
                      value={distributertag}
                      placeholder="Choose Customer LPO"
                      styles={style}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          neutral80: "#000000",
                        },
                      })}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
              <div>
                <label>
                  Customer Address <span className="mandatory">*</span>
                </label>
                <textarea
                  className="form-control"
                  placeholder="Enter Customer Address"
                  rows="5"
                ></textarea>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
              <div>
                <label>
                  Factory Order Ref <span className="mandatory">*</span>
                </label>
                <ReactSelect
                  className="basic-multi-select"
                  options={colourOptions}
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{
                    Option,
                  }}
                  onChange={handleChange}
                  allowSelectAll={true}
                  value={distributertag}
                  placeholder="Choose Factory Order Ref"
                  styles={style}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      neutral80: "#000000",
                    },
                  })}
                />
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
              <div>
                <label>
                  Sales Engineer <span className="mandatory">*</span>
                </label>
                <ReactSelect
                  className="basic-multi-select"
                  options={colourOptions}
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{
                    Option,
                  }}
                  onChange={handleChange}
                  allowSelectAll={true}
                  value={distributertag}
                  placeholder="Choose Sales Engineer"
                  styles={style}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      neutral80: "#000000",
                    },
                  })}
                />
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
              <div>
                <label>Division</label>
                <ReactSelect
                  className="basic-multi-select"
                  options={colourOptions}
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{
                    Option,
                  }}
                  onChange={handleChange}
                  allowSelectAll={true}
                  value={distributertag}
                  placeholder="Choose Division"
                  styles={style}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      neutral80: "#000000",
                    },
                  })}
                />
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
              <div>
                <label>
                  Payment Terms <span className="mandatory">*</span>
                </label>
                <ReactSelect
                  className="basic-multi-select"
                  options={colourOptions}
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{
                    Option,
                  }}
                  onChange={handleChange}
                  allowSelectAll={true}
                  value={distributertag}
                  placeholder="Choose Payment Terms"
                  styles={style}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      neutral80: "#000000",
                    },
                  })}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
              <div>
                <div>
                  <label>
                    Delivery By <span className="mandatory">*</span>
                  </label>
                  <ReactSelect
                    className="basic-multi-select"
                    options={colourOptions}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{
                      Option,
                    }}
                    onChange={handleChange}
                    allowSelectAll={true}
                    value={distributertag}
                    placeholder="Choose Delivery By"
                    styles={style}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        neutral80: "#000000",
                      },
                    })}
                  />
                </div>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
              <div className="set-expiry-date">
                <label>Delivery Date</label>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  customInput={<ExampleCustomInput />}
                  dayClassName={() => "example-datepicker-day-class"}
                  popperClassName="example-datepicker-class"
                  todayButton="TODAY"
                />
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
              <div>
                <label>
                  Taken By <span className="mandatory">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Taken By"
                ></input>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
              <div>
                <label>Contact Number(Taken By)</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Contact Number"
                ></input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
          <div className="save-btns d-flex justify-content-end">
            <button type="button" className="btn cancel-btn mr-3">
              Cancel
            </button>
            <button
              type="button"
              className="btn save-btn"
              data-toggle="modal"
              data-target="#saveSuccessModal"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddNewDeliveryProject;
